import React, { useState, useEffect } from "react";

const API = "https://danielcantos.net/api";
const GOLD = "#d4af37";
const NAVY = "#0d1b3e";
const DARK = "#0a1628";
const WHITE = "#ffffff";
const WHITE_DIM = "rgba(255,255,255,0.65)";

const token = () => localStorage.getItem("token");

const get = (path) =>
  fetch(`${API}${path}`, { headers: { Authorization: `Bearer ${token()}` } }).then((r) => r.json());

const post = (path, body) =>
  fetch(`${API}${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token()}` },
    body: JSON.stringify(body),
  }).then((r) => r.json());

const put = (path, body) =>
  fetch(`${API}${path}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token()}` },
    body: JSON.stringify(body),
  }).then((r) => r.json());

const del = (path) =>
  fetch(`${API}${path}`, {
    method: "DELETE",
    headers: { Authorization: `Bearer ${token()}` },
  }).then((r) => r.json());

const TONES = [
  { value: "formal", label: "🎩 Formal" },
  { value: "tecnico", label: "🔧 Técnico" },
  { value: "negociador", label: "🤝 Negociador" },
  { value: "comercial", label: "📈 Comercial" },
  { value: "directo", label: "⚡ Directo" },
  { value: "amigable", label: "😊 Amigable" },
];

const EMPTY_FORM = { email: "", display_name: "", role_description: "", tone: "formal", project_id: "" };

export default function ParticipantRoles() {
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState(EMPTY_FORM);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState("");
  const [search, setSearch] = useState("");

  useEffect(() => { loadRoles(); }, []);

  const loadRoles = async () => {
    setLoading(true);
    try {
      const data = await get("/roles/");
      setRoles(Array.isArray(data) ? data : []);
    } catch (e) {
      setRoles([]);
    }
    setLoading(false);
  };

  const openNew = () => {
    setForm(EMPTY_FORM);
    setEditingId(null);
    setShowForm(true);
  };

  const openEdit = (role) => {
    setForm({
      email: role.email,
      display_name: role.display_name || "",
      role_description: role.role_description || "",
      tone: role.tone || "formal",
      project_id: role.project_id || "",
    });
    setEditingId(role.id);
    setShowForm(true);
  };

  const handleSave = async () => {
    if (!form.email || !form.display_name || !form.role_description) {
      setMsg("❌ Email, nombre y descripción del rol son obligatorios");
      return;
    }
    setSaving(true);
    try {
      if (editingId) {
        await put(`/roles/${editingId}`, {
          display_name: form.display_name,
          role_description: form.role_description,
          tone: form.tone,
        });
        setMsg("✅ Rol actualizado");
      } else {
        const res = await post("/roles/", {
          ...form,
          project_id: form.project_id ? parseInt(form.project_id) : null,
        });
        if (res.detail) { setMsg(`❌ ${res.detail}`); setSaving(false); return; }
        setMsg("✅ Rol creado");
      }
      setShowForm(false);
      loadRoles();
    } catch (e) {
      setMsg("❌ Error al guardar");
    }
    setSaving(false);
    setTimeout(() => setMsg(""), 3000);
  };

  const handleDelete = async (id, name) => {
    if (!window.confirm(`¿Eliminar el rol de "${name}"?`)) return;
    await del(`/roles/${id}`);
    setMsg("🗑️ Rol eliminado");
    loadRoles();
    setTimeout(() => setMsg(""), 2500);
  };

  const filtered = roles.filter(
    (r) =>
      r.display_name?.toLowerCase().includes(search.toLowerCase()) ||
      r.email?.toLowerCase().includes(search.toLowerCase())
  );

  const inp = {
    width: "100%",
    background: "rgba(255,255,255,0.05)",
    border: "1px solid rgba(255,255,255,0.12)",
    borderRadius: 8,
    color: WHITE,
    padding: "10px 12px",
    fontSize: 13,
    outline: "none",
    boxSizing: "border-box",
  };

  const btn = (primary) => ({
    padding: "9px 18px",
    borderRadius: 8,
    border: "none",
    cursor: "pointer",
    fontWeight: 600,
    fontSize: 13,
    background: primary ? GOLD : "rgba(255,255,255,0.08)",
    color: primary ? NAVY : WHITE,
  });

  const toneLabel = (t) => TONES.find((x) => x.value === t)?.label || t;

  return (
    <div style={{ padding: "24px 28px", color: WHITE, maxWidth: 900 }}>
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
        <div>
          <h2 style={{ margin: 0, fontSize: 22, color: GOLD }}>👥 Roles de Participantes</h2>
          <p style={{ margin: "4px 0 0", fontSize: 13, color: WHITE_DIM }}>
            Cada rol define cómo el agente responde correos de ese remitente
          </p>
        </div>
        <button onClick={openNew} style={btn(true)}>+ Nuevo Rol</button>
      </div>

      {/* Mensaje */}
      {msg && (
        <div style={{ marginBottom: 16, padding: "10px 14px", background: "rgba(212,175,55,0.1)", border: `1px solid ${GOLD}`, borderRadius: 8, fontSize: 13 }}>
          {msg}
        </div>
      )}

      {/* Formulario */}
      {showForm && (
        <div style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 12, padding: 20, marginBottom: 24 }}>
          <h3 style={{ margin: "0 0 16px", fontSize: 16, color: GOLD }}>
            {editingId ? "✏️ Editar Rol" : "➕ Nuevo Rol"}
          </h3>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 12 }}>
            <div>
              <label style={{ fontSize: 12, color: WHITE_DIM, display: "block", marginBottom: 4 }}>Email del participante *</label>
              <input
                style={{ ...inp, background: editingId ? "rgba(255,255,255,0.02)" : inp.background }}
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                placeholder="proveedor@empresa.com"
                disabled={!!editingId}
              />
            </div>
            <div>
              <label style={{ fontSize: 12, color: WHITE_DIM, display: "block", marginBottom: 4 }}>Nombre / Cargo *</label>
              <input
                style={inp}
                value={form.display_name}
                onChange={(e) => setForm({ ...form, display_name: e.target.value })}
                placeholder="Carlos Mendoza – Proveedor Pemeal"
              />
            </div>
          </div>

          <div style={{ marginBottom: 12 }}>
            <label style={{ fontSize: 12, color: WHITE_DIM, display: "block", marginBottom: 4 }}>
              Descripción del rol * — define quién es, qué posiciones toma, cómo negocia
            </label>
            <textarea
              style={{ ...inp, minHeight: 110, resize: "vertical", fontFamily: "inherit" }}
              value={form.role_description}
              onChange={(e) => setForm({ ...form, role_description: e.target.value })}
              placeholder={`Ejemplo:\nCarlos es proveedor de camarón entero fresco de la empresa Pemeal. Tiene posiciones firmes sobre precio mínimo de $4.20/lb y exige pago a 30 días. Es formal pero flexible en volumen. Conoce el mercado centroamericano y suele ofrecer descuentos por volumen mayor a 5 TM.`}
            />
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 16 }}>
            <div>
              <label style={{ fontSize: 12, color: WHITE_DIM, display: "block", marginBottom: 4 }}>Tono de comunicación</label>
              <select
                style={{ ...inp, cursor: "pointer" }}
                value={form.tone}
                onChange={(e) => setForm({ ...form, tone: e.target.value })}
              >
                {TONES.map((t) => (
                  <option key={t.value} value={t.value} style={{ background: DARK }}>
                    {t.label}
                  </option>
                ))}
              </select>
            </div>
            {!editingId && (
              <div>
                <label style={{ fontSize: 12, color: WHITE_DIM, display: "block", marginBottom: 4 }}>ID de proyecto (opcional)</label>
                <input
                  style={inp}
                  type="number"
                  value={form.project_id}
                  onChange={(e) => setForm({ ...form, project_id: e.target.value })}
                  placeholder="3"
                />
              </div>
            )}
          </div>

          <div style={{ display: "flex", gap: 10 }}>
            <button onClick={handleSave} disabled={saving} style={btn(true)}>
              {saving ? "Guardando..." : editingId ? "Actualizar" : "Crear Rol"}
            </button>
            <button onClick={() => setShowForm(false)} style={btn(false)}>Cancelar</button>
          </div>
        </div>
      )}

      {/* Buscador */}
      {roles.length > 0 && (
        <input
          style={{ ...inp, marginBottom: 16, maxWidth: 320 }}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="🔍 Buscar por nombre o email..."
        />
      )}

      {/* Lista */}
      {loading ? (
        <div style={{ color: WHITE_DIM, fontSize: 14 }}>Cargando roles...</div>
      ) : filtered.length === 0 ? (
        <div style={{ textAlign: "center", padding: "40px 0", color: WHITE_DIM }}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>👤</div>
          <div style={{ fontSize: 15 }}>
            {roles.length === 0 ? "Aún no hay roles definidos" : "Sin resultados"}
          </div>
          {roles.length === 0 && (
            <div style={{ fontSize: 13, marginTop: 6 }}>
              Crea el primer rol para que el agente pueda responder en nombre de tus contactos
            </div>
          )}
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {filtered.map((role) => (
            <div
              key={role.id}
              style={{
                background: "rgba(255,255,255,0.03)",
                border: "1px solid rgba(255,255,255,0.08)",
                borderRadius: 10,
                padding: "14px 16px",
                display: "flex",
                alignItems: "flex-start",
                gap: 14,
              }}
            >
              {/* Avatar */}
              <div style={{
                width: 40, height: 40, borderRadius: "50%",
                background: `linear-gradient(135deg, ${GOLD}, #b8962e)`,
                display: "flex", alignItems: "center", justifyContent: "center",
                fontWeight: 700, fontSize: 16, color: NAVY, flexShrink: 0,
              }}>
                {(role.display_name || "?")[0].toUpperCase()}
              </div>

              {/* Info */}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 2 }}>
                  <span style={{ fontWeight: 600, fontSize: 14 }}>{role.display_name}</span>
                  <span style={{ fontSize: 11, padding: "2px 8px", borderRadius: 20, background: "rgba(212,175,55,0.15)", color: GOLD }}>
                    {toneLabel(role.tone)}
                  </span>
                </div>
                <div style={{ fontSize: 12, color: WHITE_DIM, marginBottom: 6 }}>📧 {role.email}</div>
                <div style={{ fontSize: 12, color: "rgba(255,255,255,0.4)", lineHeight: 1.5 }}>
                  {role.role_description?.slice(0, 160)}{role.role_description?.length > 160 ? "..." : ""}
                </div>
              </div>

              {/* Acciones */}
              <div style={{ display: "flex", gap: 8, flexShrink: 0 }}>
                <button onClick={() => openEdit(role)} style={{ ...btn(false), padding: "6px 12px", fontSize: 12 }}>
                  ✏️ Editar
                </button>
                <button
                  onClick={() => handleDelete(role.id, role.display_name)}
                  style={{ ...btn(false), padding: "6px 12px", fontSize: 12, background: "rgba(220,38,38,0.15)", color: "#f87171" }}
                >
                  🗑️
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      <div style={{ marginTop: 24, padding: "12px 14px", background: "rgba(255,255,255,0.02)", borderRadius: 8, fontSize: 12, color: WHITE_DIM }}>
        💡 Cuando llegue un correo de uno de estos remitentes, el agente responderá adoptando automáticamente su rol y tono definidos aquí.
      </div>
    </div>
  );
}
